module.exports = __webpack_public_path__ + "img/EN.f0c9ac22.svg";